import type { MenuProps } from 'antd';
import MeetingModeIcon from './images/meeting.svg?react';
// import MessageIcon from './images/message.svg?react';
// import ParticipantsIcon from './images/participants.svg?react';
// import SettingIcon from './images/setting.svg?react';
import FullScreenIcon from './images/fullScreen.svg?react';
import styles from './index.module.scss';
import type { MoreOperateProps } from './type';
import { MoreOperateKey } from './type';

const MoreOperate = ({ children, onClick }: MoreOperateProps) => {
  const items: MenuProps['items'] = [
    {
      key: MoreOperateKey.MEET,
      label: (
        <div className={styles.menuLabel}>
          Share Screen <MeetingModeIcon />
        </div>
      ),
    },
    // {
    //   key: MoreOperateKey.MESSAGES,
    //   label: (
    //     <div className={styles.menuLabel}>
    //       Send Messages <MessageIcon />
    //     </div>
    //   ),
    // },
    // {
    //   key: MoreOperateKey.PARTICIPANTS,
    //   label: (
    //     <div className={styles.menuLabel}>
    //       Participants <ParticipantsIcon />
    //     </div>
    //   ),
    // },
    {
      key: MoreOperateKey.FULL_SCREEN,
      label: (
        <div className={styles.menuLabel}>
          Full screen <FullScreenIcon />
        </div>
      ),
    },
    // {
    //   type: 'divider',
    // },
    // {
    //   key: MoreOperateKey.SETTING,
    //   label: (
    //     <div className={styles.menuLabel}>
    //       Setting <SettingIcon />
    //     </div>
    //   ),
    // },
  ];
  return (
    <Dropdown
      overlayClassName={styles.dropdownwrapper}
      menu={{
        items,
        onClick,
      }}
      placement="top"
      getPopupContainer={(e) => e.parentElement as HTMLDivElement}
    >
      <div>{children}</div>
    </Dropdown>
  );
};
export default MoreOperate;
